import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    setSuccess(false);

    try {
      const apiUrl = 'https://naus-backend.onrender.com/api';
      await axios.post(`${apiUrl}/auth/forgot-password`, { email });
      setSuccess(true);
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || 'An error occurred. Please try again.');
      } else {
        setError('Cannot connect to server. Please check your connection.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="section" style={{ padding: '4rem 1rem' }}>
      <div className="container">
        <div style={{
          backgroundColor: '#fff',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          margin: '0 auto'
        }}>
          <h2 style={{ color: '#1b4d3e', textAlign: 'center', marginBottom: '1.5rem' }}>
            Forgot Password
          </h2>

          {success ? (
            <div>
              <div style={{
                backgroundColor: '#d4edda',
                color: '#155724',
                padding: '1rem',
                borderRadius: '4px',
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Check your email!</p>
                <p style={{ margin: 0, fontSize: '0.9rem' }}>
                  If an account exists with that email, we've sent password reset instructions.
                </p>
              </div>
              <Link
                to="/member-login"
                style={{
                  display: 'block',
                  textAlign: 'center',
                  color: '#1b4d3e',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  marginTop: '1rem'
                }}
              >
                Back to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p style={{ color: '#666', textAlign: 'center', marginBottom: '1.5rem', fontSize: '0.95rem' }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>

              <div style={{ marginBottom: '1rem' }}>
                <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="your.email@example.com"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '1rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {error && (
                <div style={{
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  padding: '0.75rem',
                  borderRadius: '4px',
                  marginBottom: '1rem',
                  fontSize: '0.9rem'
                }}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  width: '100%',
                  backgroundColor: '#1b4d3e',
                  color: '#fff',
                  padding: '1rem',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
              >
                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
              </button>

              <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                <Link to="/member-login" style={{ color: '#1b4d3e', textDecoration: 'none', fontWeight: 'bold' }}>
                  Back to Login
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;